export const EXSBDOCUMENT_CREATE_RESET = 'EXSBDOCUMENT_CREATE_RESET'
export const EXSBDOCUMENT_CREATE_SET_CREATED = 'EXSBDOCUMENT_CREATE_SET_CREATED'
export const EXSBDOCUMENT_CREATE_SET_ERROR = 'EXSBDOCUMENT_CREATE_SET_ERROR'
export const EXSBDOCUMENT_CREATE_SET_VIOLATIONS = 'EXSBDOCUMENT_CREATE_SET_VIOLATIONS'
export const EXSBDOCUMENT_CREATE_TOGGLE_LOADING = 'EXSBDOCUMENT_CREATE_TOGGLE_LOADING'
